/**
 * NOT CHECKED
 */
import React from 'react';

import DocumentSignatureIcon from '@uikit/old/Icon/svgIcons/DocumentSignatureIcon';
import PersonRoundedCrossedIcon from '@uikit/old/Icon/svgIcons/PersonRoundedCrossedIcon';
import ArrowRightClassicIcon from '@uikit/old/Icon/svgIcons/ArrowRightClassicIcon';
import FlagStripedIcon from '@uikit/old/Icon/svgIcons/FlagStripedIcon';
import ConnectionIcon from '@uikit/old/Icon/svgIcons/ConnectionIcon';
import CardioIcon from '@uikit/old/Icon/svgIcons/CardioIcon';
import LinkChainIcon from '@uikit/old/Icon/svgIcons/LinkChainIcon';
import PencilIcon from '@uikit/old/Icon/svgIcons/PencilIcon';
import cubesIcon from '@uikit/old/Icon/svgIcons/CubesIcon';
import LightBulbIcon from '@uikit/old/Icon/svgIcons/LightBulbIcon';
import CheckCircled2Icon from '@uikit/old/Icon/svgIcons/CheckCircled2Icon';
import Wallet2Icon from '@uikit/old/Icon/svgIcons/Wallet2Icon';
import BillIcon from '@uikit/old/Icon/svgIcons/BillIcon';
import StopMessagingIcon from '@uikit/old/Icon/svgIcons/StopMessagingIcon';
import RenameActionIcon from '@uikit/old/Icon/svgIcons/RenameActionIcon';
import KeyIcon from '@uikit/old/Icon/svgIcons/KeyIcon';
import LineChartMinimalIcon from '@uikit/old/Icon/svgIcons/LineChartMinimalIcon';
import CheckCircledIcon from '@uikit/old/Icon/svgIcons/CheckCircledIcon';
import InboxIcon from '@uikit/old/SidebarIcon/_components/InboxIcon';
import ArrowUpCircle from '@uikit/old/Icon/svgIcons/ArrowUpCircle';
import PersonIcon from '@uikit/old/Icon/svgIcons/PersonIcon';
import PersonRoundedIcon from '@uikit/old/Icon/svgIcons/PersonRoundedIcon';
import ExpandSidebarIcon from '@uikit/old/Icon/svgIcons/ExpandSidebarIcon';
import ExternalLinkIcon from '@uikit/old/Icon/svgIcons/ExternalLinkIcon';
import SuccessCircleFilledIcon from '@uikit/old/Icon/svgIcons/SuccessCircleFilledIcon';
import TrashSimpleIcon from '@uikit/old/Icon/svgIcons/TrashSimpleIcon';
import ArchivedInboxIcon from '@uikit/old/Icon/svgIcons/ArchivedInboxIcon';
import TextMessageIcon from '@uikit/old/Icon/svgIcons/TextMessageIcon';
import OpenMessageIcon from '@uikit/old/Icon/svgIcons/OpenMessageIcon';
import InboxUnreadMessage from '@uikit/old/Icon/svgIcons/InboxUnreadMessage';
import CalendarIcon from '@uikit/old/Icon/svgIcons/CalendarIcon';
import PauseTallIcon from '@uikit/old/Icon/svgIcons/PauseTallIcon';
import EmailIcon from '@uikit/old/Icon/svgIcons/EmailIcon';
import SocketPlugIcon from '@uikit/old/Icon/svgIcons/SocketPlugIcon';
import LinkBrokenIcon from '@uikit/old/Icon/svgIcons/LinkBrokenIcon';
import AiIcon from '@uikit/old/Icon/svgIcons/AiIcon';
import NumberIcon from '@uikit/old/Icon/svgIcons/NumberIcon';
import TextLetterIcon from '@uikit/old/Icon/svgIcons/TextLetterIcon';
import CrosedIcon from '@uikit/old/Icon/svgIcons/CrosedIcon';
import EmailPersonalized from '@uikit/old/Icon/svgIcons/EmailPersonalized';
import UserSearch from '@uikit/old/Icon/svgIcons/UserSearch';
import MetricIcon from '@uikit/old/Icon/svgIcons/MetricIcon';
import FoldersIcon from '@uikit/old/Icon/svgIcons/FoldersIcon';
import LockIcon from '@uikit/old/Icon/svgIcons/LockIcon';
import FlagMarkIcon from '@uikit/old/Icon/svgIcons/FlagMarkIcon';
import ModelIcon from '@uikit/old/Icon/svgIcons/ModelIcon';
import ManualIcon from '@uikit/old/Icon/svgIcons/ManualIcon';
import SparklesIcon from '@uikit/old/Icon/svgIcons/SparklesIcon';

// @ts-ignore
import ImageVideoFile from '@uikit/old/Icon/svgIcons/ImageVideoFile';
import RepliedNotInterestedIcon from '@uikit/old/Icon/svgIcons/RepliedNotInterestedIcon';
import RepliedInterestedIcon from '@uikit/old/Icon/svgIcons/RepliedInterestedIcon';
import ArrowRefreshCircle from '@uikit/old/Icon/svgIcons/ArrowRefreshCircle';
import GoogleIcon from '@uikit/old/Icon/svgIcons/googleIcon';
import SemrushSearchSvg from '@components/CampaignSettings/ContentSearch/ContentAutomationSearch/_components/SearchTypesTab/assets/SemrushSearchSvg';
import BingShortSVG from '@components/CampaignSettings/ContentSearch/ContentAutomationSearch/assets/BingShortSVG';
import UploadShortSVG from '@components/CampaignSettings/ContentSearch/ContentAutomationSearch/assets/UploadShortSVG';
import KeywordsSearcgSVG from '@components/CampaignSettings/ContentSearch/ContentAutomationSearch/_components/SearchTypesTab/assets/KeywordsSearcgSVG';
import PodcastSVG from '@components/CampaignSettings/ContentSearch/ContentAutomationSearch/_components/SearchTypesTab/assets/PodcastSVG';
import RelationshipsSVG from '@components/CampaignSettings/ContentSearch/ContentAutomationSearch/assets/RelationshipsSVG';
import BingNewsShortSVG from '@components/CampaignSettings/ContentSearch/ContentAutomationSearch/assets/BingNewsShortSVG';
import EpisodesSVG from '@components/CampaignSettings/ContentSearch/ContentAutomationSearch/assets/EpisodesSVG';
import CSVImportSVG from '@components/CampaignSettings/ContentSearch/ContentAutomationSearch/_components/SearchTypesTab/assets/CSVImportSVG';
import CrossInGreyCircle from '@uikit/old/Icon/svgIcons/CrossInGreyCircle';
import PlayBigIcon from '@uikit/old/Icon/svgIcons/PlayBigIcon';
import QuestionMark from '@uikit/old/Icon/svgIcons/QuestionMark';
import BlueMark from '@uikit/old/Icon/svgIcons/BlueMark';
import TimeIcon from '@uikit/old/Icon/svgIcons/TimeIcon';
import CancelIcon from '@uikit/old/Icon/svgIcons/CancelIcon';
import MozSVG from '@components/CampaignSettings/ContentSearch/ContentAutomationSearch/_components/SearchTypesTab/assets/MozSVG';
// @ts-ignore
import ThreeDots from '@uikit/old/Icon/svgIcons/ThreeDots';
import House from '@uikit/old/Icon/svgIcons/House';
import LockGrey from '@uikit/old/Icon/svgIcons/LockGrey';
import Pin from '@uikit/old/Icon/svgIcons/Pin';
import LightningArrowIcon from '@uikit/old/Icon/svgIcons/LightningArrowIcon';
import PlayArrowIcon from '@uikit/old/Icon/svgIcons/PlayArrowIcon';
import CheckMarkIcon from '@uikit/old/Icon/svgIcons/checkMarkIcon';
import PieChartIcon from '@uikit/old/Icon/svgIcons/PieChartIcon';
import RefreshCircleIcon from '@uikit/old/Icon/svgIcons/RefreshCircleIcon';
import ChatGPTicon from '@uikit/old/Icon/svgIcons/ChatGPTicon';
// @ts-ignore
import CheckListIcon from '@uikit/old/Icon/svgIcons/CheckListIcon';
import ReduceIcon from '@uikit/old/Icon/svgIcons/ReduceIcon';
import TranslateIcon from '@uikit/old/Icon/svgIcons/TranslateIcon';
import RelaxedSmile from '@uikit/old/Icon/smiles/RelaxedSmile';
import BriefCaseIcon from '@uikit/old/Icon/smiles/BriefCaseIcon';
import ShySmileIcon from '@uikit/old/Icon/smiles/ShySmileIcon';
import TearsSmileIcon from '@uikit/old/Icon/smiles/TearsSmileIcon';
import LabelIcon from '@uikit/old/Icon/svgIcons/LabelIcon';
import CrossedOutCircle from '@uikit/old/Icon/svgIcons/CrossedOutCircle';
import draftIcon from '@uikit/old/Icon/svgIcons/DraftIcon';
import AssignedPersonIcon from '@uikit/old/Icon/svgIcons/AssignedPersonIcon';
import PersonsIcon from '@uikit/old/Icon/svgIcons/PersonsIcon';
import StatusBox from '@uikit/old/Icon/svgIcons/StatusBox';
import FullStarIcon from '@uikit/old/Icon/svgIcons/FullStarIcon';
import AvatarIcon from '@uikit/old/Icon/svgIcons/AvatarIcon';
import Bounced from '@uikit/old/Icon/svgIcons/Bounced';
import SelectIcon from '@uikit/old/Icon/svgIcons/SelectIcon';
import TeamMemberIcon from '@uikit/old/Icon/svgIcons/TeamMemberIcon';
import CheckboxIcon from '@uikit/old/Icon/svgIcons/CheckboxIcon';
import RatingIcon from '@uikit/old/Icon/svgIcons/RatingIcon';
import MultiSelectIcon from '@uikit/old/Icon/svgIcons/MultiSelectIcon';
import DateTimeIcon from '@uikit/old/Icon/svgIcons/DateTimeIcon';
import DragAndDropIcon from '@uikit/old/Icon/svgIcons/DragAndDropIcon';
import ShareWithUsIcon from '@uikit/old/Icon/svgIcons/ShareWithUsIcon';
import RecurringIcon from '@uikit/old/Icon/svgIcons/RecurringIcon';
import CreatedOpportunitiesIcon from '@uikit/old/Icon/svgIcons/CreatedOpportunitiesIcon';
import CreditsIcon from '@uikit/old/Icon/svgIcons/CreditsIcon';
import FlaggedIcon from '@uikit/old/Icon/svgIcons/FlaggedIcon';
import ReportIcon from '@uikit/old/Icon/svgIcons/ReportIcon';
import XIcon from '@uikit/old/Icon/svgIcons/XIcon';
import CoinsIcon from '@uikit/old/Icon/svgIcons/CoinsIcon';
import CancelCircle from '@uikit/old/Icon/svgIcons/CancelCircle';
import DuplicateIcon from '@uikit/old/Icon/svgIcons/DuplicateIcon';
import OpportunitiesIcon from '@uikit/old/Icon/svgIcons/OpportunitiesIcon';
import RepliedWonIcon from '@uikit/old/Icon/svgIcons/RepliedWonIcon';
import RepliedLostIcon from '@uikit/old/Icon/svgIcons/RepliedLostIcon';
import aiStarIcon from '@uikit/old/Icon/svgIcons/aiStarIcon';
import SendArrowIcon from '@uikit/old/Icon/svgIcons/sendArrowIcon';
import Duplicate from '@uikit/old/Icon/svgIcons/Duplicate';
import AiAvatarIcon from '@uikit/old/Icon/socialSvg/AiAvatarIcon';
import ViewIcon from '@uikit/old/Icon/svgIcons/ViewIcon';
import AiChatIcon from '@uikit/old/Icon/svgIcons/AiChatIcon';
import ConfigurationIcon from '@uikit/old/Icon/svgIcons/ConfigurationIcon';
import BucketLinkIcon from '@uikit/old/Icon/svgIcons/BucketLinkIcon';
import SquareLinkIcon from '@uikit/old/Icon/svgIcons/SquareLinkIcon';
import TimerIcon from '@uikit/old/Icon/svgIcons/TimerIcon';
import LightningIcon from '@uikit/old/Icon/svgIcons/LightningIcon';
import ToggleIcon from '@uikit/old/Icon/svgIcons/ToggleIcon';
import QuestionIcon from '@uikit/old/Icon/svgIcons/QuestionIcon';
import PlanetWithCheckmark from '@uikit/old/Icon/svgIcons/PlanetWithCheckmark';
import TaskCompleted from '@uikit/old/Icon/svgIcons/TaskCompleted';
import FlashIcon from '@uikit/old/Icon/svgIcons/FlashIcon';
import LinkSingleChain from '@uikit/old/Icon/svgIcons/LinkSingleChain';
import BucketWithArrow from '@uikit/old/Icon/svgIcons/BucketWithArrow';
import WidgetIcon from '@uikit/old/Icon/svgIcons/WidgetIcon';
import EaselIcon from '@uikit/old/Icon/svgIcons/EaselIcon';
import PlayArrowInCircle from '@uikit/old/Icon/svgIcons/PlayArrowInCircle';
import ThreeDotsInCircle from '@uikit/old/Icon/svgIcons/ThreeDotsInCircle';
import EyeInCircle from '@uikit/old/Icon/svgIcons/EyeInCircle';
import SpinnerDotsIcon from '@uikit/old/Icon/svgIcons/SpinnerDotsIcon';
import InvoiceIcon from '@uikit/old/Icon/svgIcons/InvoiceIcon';
import DownloadInCircle from '@uikit/old/Icon/svgIcons/downloadInCircle';
import PurpleStarIcon from '@uikit/old/Icon/svgIcons/PurpleStarIcon';
import PencilInCircle from '@uikit/old/Icon/svgIcons/PencilInCircle';
import LightningArrowInCircle from '@uikit/old/Icon/svgIcons/lightningArrowInCircle';
import CheckInCircleIcon from '@uikit/old/Icon/svgIcons/checkInCircleIcon';
import CrossInRedCircle from '@uikit/old/Icon/svgIcons/CrossInRedCircle';
import BucketInCircleIcon from '@uikit/old/Icon/svgIcons/BucketInCircleIcon';
import PenInCircle from '@uikit/old/Icon/svgIcons/PenInCircle';
import CreditCardWithPlus from '@uikit/old/Icon/svgIcons/CreditCardWithPlus';
import TwoStarIcon from '@uikit/old/Icon/svgIcons/TwoStarIcon';
import ChatGPT from '@uikit/old/Icon/socialSvg/ChatGPT';
import Claude from '@uikit/old/Icon/socialSvg/Claude';
import GoogleAi from '@uikit/old/Icon/socialSvg/GoogleAi';
import Perplexity from '@uikit/old/Icon/socialSvg/Perplexity';
import AIOverviews from '@uikit/old/Icon/socialSvg/AIOverviews';
import TwoAiStartsIcon from '@uikit/old/Icon/svgIcons/TwoAiStartsIcon';
// @ts-ignore
import mailIcon from './assets/mail-icon.svg';
// @ts-ignore
import responaSmall from './assets/respona-small.svg';
// @ts-ignore
import arrowLeftCircle from './assets/arrow-left-circle.svg';
// @ts-ignore
import info from './assets/info.svg';
// @ts-ignore
import check from './assets/check.svg';
// @ts-ignore
import wallet from './assets/wallet.svg';
// @ts-ignore
import arrowDown from './assets/arrow-down.svg';
// @ts-ignore
import arrowUp from './assets/arrow-up.svg';
// @ts-ignore
import search from './assets/search.svg';
// @ts-ignore
import statusEdit from './assets/status-edit.svg';
// @ts-ignore
import statusSwap from './assets/status-swap.svg';
// @ts-ignore
import statusSuccess from './assets/status-success.svg';
// @ts-ignore
import statusPause from './assets/status-pause.svg';
// @ts-ignore
import personIcon from './assets/person-icon.svg';
// @ts-ignore
import companyIcon from './assets/company.svg';
// @ts-ignore
import chevron from './assets/chevron.svg';

import MinusCircle from './svgIcons/MinusCircle';
import DocumentIcon from './svgIcons/DocumentIcon';
import PlusCircle from './svgIcons/PlusCircle';
import SlidersSettings from './svgIcons/SlidersSettings';
import Copy, { CopyIcon2, CopyIcon3 } from './svgIcons/Copy';
import MessageIcon from './svgIcons/MessageIcon';
import ArrowLeftCircle from './svgIcons/ArrowLeftCircle';
import ArrowLeft from './svgIcons/ArrowLeft';
import PlusIcon from './svgIcons/PlusIcon';
import ArrowDownIcon from './svgIcons/ArrowDownIcon';
import Info from './svgIcons/Info';
import Infinity from './svgIcons/Infinity';
import Trash from './svgIcons/Trash';
import BoldTextIcon from './svgIcons/BoldTextIcon';
import ItalicTextIcon from './svgIcons/ItalicTextIcon';
import UnderlineTextIcon from './svgIcons/UnderlineTextIcon';
import OrderedListIcon from './svgIcons/OrderedListIcon';
import UnorderedListIcon from './svgIcons/UnorderedListIcon';
import Pen from './svgIcons/Pen';
import SearchIcon from './svgIcons/SearchIcon';
import CrossEdit from './svgIcons/CrossEdit';
import PrevPageIcon from './svgIcons/PrevPageIcon';
import NextPageIcon from './svgIcons/NextPageIcon';
import UserIcon from './svgIcons/UserIcon';
import LinkIcon from './svgIcons/LinkIcon';
import NotificationsIcon from './svgIcons/NotificationsIcon';
import LocationIcon from './svgIcons/LocationIcon';
import PersonWithMinus from './svgIcons/PersonWithMinus';
import RefreshIconOneArrowAround from './svgIcons/RefreshIconOneArrowAround';
import WorkspaceOutIcon from './svgIcons/WorkspaceOutIcon';
import PlayIcon from './svgIcons/PlayIcon';
import PlayRoundedIcon from './svgIcons/PlayRoundedIcon';
import ProfileIcon from './svgIcons/ProfileIcon';
import CompanyIcon from './svgIcons/CompanyIcon';
import BillingIcon from './svgIcons/BillingIcon';
import WorkspacesIcon from './svgIcons/WorkspacesIcon';
import MemberIcon from './svgIcons/MemberIcon';
import FolderIcon from './svgIcons/FolderIcon';
import AllMembersIcon from './svgIcons/AllMembersIcon';
import EmailsIcon from './svgIcons/EmailsIcon';
import EmailFind from './svgIcons/EmailFindIcon';
import EmailVerify from './svgIcons/EmailVerifyIcon';
import BookmarkIcon from './svgIcons/BookmarkIcon';
import SchedulesIcon from './svgIcons/SchedulesIcon';
import CrossDeleteIcon from './svgIcons/CrossDeleteIcon';
import CrossInCircleIcon from './svgIcons/CrossInCircleIcon';
import RocketIcon from './svgIcons/RocketIcon';
import CrossBlackIcon from './svgIcons/CrossBlackIcon';
import WarningTriangleIcon from './svgIcons/WarningTriangleIcon';
import WarningTriangleCircleIcon from './svgIcons/WarningTriangleCircleIcon';
import LaunchingIcon from './svgIcons/LaunchingIcon';
import SuccessCircleIcon from './svgIcons/SuccessCircleIcon';
import ActionsIcon from './svgIcons/ActionsIcon';
import ShareIcon from './svgIcons/ShareIcon';
import TrashWhiteIcon from './svgIcons/TrashWhiteIcon';
import EditActionIcon from './svgIcons/EditActionIcon';
import EnvelopeIcon from './svgIcons/EnvelopeIcon';
import CheckIcon from './svgIcons/CheckIcon';
import ChevronIcon from './svgIcons/ChevronIcon';
import GearIcon from './svgIcons/GearIcon';
import CloseIcon from './svgIcons/CrosedIcon';
import ImportIcon from './svgIcons/ImportIcon';
import PauseBlueIcon from './svgIcons/PauseBlueIcon';
import PlayBlueIcon from './svgIcons/PlayBlueIcon';
import AddUserWhiteIcon from './svgIcons/AddUserWhiteIcon';
import PauseIcon from './svgIcons/PauseIcon';
import ArrowRightGreyIcon from './svgIcons/ArrowRightGreyIcon';
import WindowSectionIcon from './svgIcons/WindowSectionIcon';
import CrownIcon from './svgIcons/CrownIcon';
import BanWhiteIcon from './svgIcons/BanWhiteIcon';
import TagWhiteIcon from './svgIcons/TagWhiteIcon';
import InboxWhiteIcon from './svgIcons/InboxWhiteIcon';
import FolderWhiteIcon from './svgIcons/FolderWhiteIcon';
import FolderOpenIcon from './svgIcons/FolderOpenIcon';
import AddCompanyIcon from './svgIcons/AddCompanyIcon';
import InsightsIcon from './svgIcons/InsightsIcon';
import BarChartIcon from './svgIcons/BarChartIcon';
import LineChartIcon from './svgIcons/LineChartIcon';
import SaveIcon from './svgIcons/SaveIcon';
import VideoIcon from './svgIcons/VideoIcon';
import WalletIcon from './svgIcons/WalletIcon';
import List from './svgIcons/List';
import CrossList from './svgIcons/CrossList';
import AppleIcon from './svgIcons/AppleIcon';
import RrsIcon from './svgIcons/RrsIcon';
import CommentIcon from './svgIcons/CommentIcon';
import DownloadIcon from './svgIcons/DownloadIcon';
import SuitcaseIcon from './svgIcons/SuitcaseIcon';
import BuildingIcon from './svgIcons/BuildingIcon';
import OfficeIcon from './svgIcons/OfficeIcon';
import ProfileCrossBigIcon from './svgIcons/ProfileCrossBigIcon';
import BracketsIcon from './svgIcons/BracketsIcon';
import InfoCommentIcon from './svgIcons/InfoCommentIcon';
import DoubleCheckmarkIcon from './svgIcons/DoubleCheckmarkIcon';
import GreyRoundCheckmarkIcon from './svgIcons/GreyRoundCheckmarkIcon';
import InquiriesIcon from './svgIcons/InquiriesIcon';
import FilterIcon from './svgIcons/FilterIcon';
import PriceTagIcon from './svgIcons/PriceTagIcon';
import GlobeIcon from './svgIcons/GlobeIcon';
import ErrorInputFieldSignIcon from './svgIcons/ErrorInputFieldSignIcon';
import DownloadFileIcon from './svgIcons/DownloadFileIcon';
import StarIcon from './svgIcons/StarIcon';
import StarFilledIcon from './svgIcons/StarFilledIcon';
import UploadIcon from './svgIcons/UploadIcon';
import FlagIcon from './svgIcons/FlagIcon';
import CurvesIcon from './svgIcons/CurvesIcon';
import VolumeIcon from './svgIcons/VolumeIcon';
import VolumeMuteIcon from './svgIcons/VolumeMuteIcon';
import SpinnerIcon from './svgIcons/SpinnerIcon';
import ClockThreeIcon from './svgIcons/ClockThreeIcon';
import RefreshIcon from './svgIcons/RefreshIcon';
import RemoveRelationshipsIcon from './svgIcons/RemoveRelationshipsIcon';
import CreditCardIcon from './svgIcons/CreditCardIcon';
import TwoDotsActionsIcon from './svgIcons/TwoDotsActionsIcon';
import LogoutIcon from './svgIcons/LogoutIcon';
import AttachmentIcon from './svgIcons/AttachmentIcon';
import ImageIcon from './svgIcons/ImageIcon';
import SelectedOpportunitiesAbsoluteIcon from './svgIcons/SelectedOpportunitiesAbsoluteIcon';
import EmptySelectedOpportunitiesIcon from './svgIcons/EmptySelectedOpportunitiesIcon';
import WarningRoundedSignIcon from './svgIcons/WarningRoundedSignIcon';
import PlaneIcon from './svgIcons/PlaneIcon';
import HeartIcon from './svgIcons/HeartIcon';
import HeartCrossIcon from './svgIcons/HeartCrossIcon';
import BasketballIcon from './svgIcons/BasketballIcon';
import UserMinusIcon from './svgIcons/UserMinusIcon';
import UserPlusIcon from './svgIcons/UserPlusIcon';
import CommentsIcon from './svgIcons/CommentsIcon';
import TrophyIcon from './svgIcons/TrophyIcon';
import TrophyCrossIcon from './svgIcons/TrophyCrossIcon';
import SentIcon from './svgIcons/SentIcon';
import OutboxIcon from './svgIcons/OutboxIcon';
import NeedAttentionIcon from './svgIcons/NeedAttentionIcon';
import SequenceIcon from './svgIcons/SequenceIcon';
import ChecklistItemSuccesIcon from './svgIcons/ChecklistItemSuccesIcon';
import ResponaSmallIcon from './svgIcons/ResponaSmallIcon';
import ActionHorizontal from './svgIcons/ActionHorizontal';
import FileBlankIcon from './svgIcons/FileBlankIcon';
import CornerUpLeftIcon from './svgIcons/CornerUpLeftIcon';
import DoubleCornerUpLeftIcon from './svgIcons/DoubleCornerUpLeftIcon';
import SpamIcon from './svgIcons/SpamIcon';
import ArchiveIcon from './svgIcons/ArchiveIcon';
import SnoozeIcon from './svgIcons/SnoozeIcon';

import AngelListIcon from './socialSvg/AngelListIcon';
import AppStoreIcon from './socialSvg/AppStoreIcon';
import CrunchBaseIcon from './socialSvg/CrunchBaseIcon';
import FacebookIcon from './socialSvg/FacebookIcon';
import GithubIcon from './socialSvg/GithubIcon';
import GooglePlayIcon from './socialSvg/GooglePlayIcon';
import InstagramIcon from './socialSvg/InstagramIcon';
import LinkedinIcon from './socialSvg/LinkedinIcon';
import MediumIcon from './socialSvg/MediumIcon';
import PenterestIcon from './socialSvg/PenterestIcon';
import QuoraIcon from './socialSvg/QuoraIcon';
import RedditIcon from './socialSvg/RedditIcon';
import SnapchatIcon from './socialSvg/SnapchatIcon';
import SpotifyIcon from './socialSvg/SpotifyIcon';
import TikTokIcon from './socialSvg/TikTokIcon';
import TwitterIcon from './socialSvg/TwitterIcon';
import YoutubeIcon from './socialSvg/YoutubeIcon';
import ShieldIcon from './svgIcons/ShieldIcon';
import EditProfileImagePenIcon from './svgIcons/EditProfileImagePenIcon';
import QuestionInCircle from './svgIcons/QuestionInCircle';
import QuestionInCircleFilled from './svgIcons/QuestionInCircleFilled';
import SidebarDashBoardIcon from './svgIcons/SidebarDashBoardIcon';
import AllCampaignsSidebarIcon from './svgIcons/AllCampaignsSidebarIcon';
import PenSquared from './svgIcons/PenSquared';
import VisaIcon from './svgIcons/VisaIcon';
import BellIcon from './svgIcons/BellIcon';
import VerifyPlayIcon from './svgIcons/VerifyPlayIcon';
import CheckmarkInCircleIcon from './svgIcons/CheckmarkInCircleIcon';
import ExclamationMarkInCircleIcon from './svgIcons/ExclamationMarkInCircleIcon';
import VerifyiedOpportunityIcon from './svgIcons/VerifyiedOpportunityIcon';
import ChatUnfilledIcon from './svgIcons/ChatUnfilledIcon';
import TextAlignmentIcon from './svgIcons/TextAlignmentIcon';
import TextAlignmentLeftIcon from './svgIcons/TextAlignmentLeftIcon';
import TextAlignmentCenterIcon from './svgIcons/TextAlignmentCenterIcon';
import TextAlignmentRightIcon from './svgIcons/TextAlignmentRightIcon';
import SpeechBoxIcon from './svgIcons/SpeechBoxIcon';
import ReportBox from './svgIcons/ReportBox';
import ScaleIcon from './svgIcons/ScaleIcon';
import EmailHealthIcon from './svgIcons/EmailHealthIcon';
import LayoutIcon from './svgIcons/LayoutIcon';
import RateGraphic from './svgIcons/RateGraphic';
import CurveGraphIcon from './svgIcons/CurveGraphIcon';
import DownloadDocumentIcon from './svgIcons/DownloadDocumentIcon';
import SortUpArrow from './svgIcons/SortUpArrow';
import SortDownArrow from './svgIcons/SortDownArrow';
import BuildBacklinks from './svgIcons/BuildBacklinks';
import BookPodcastsInterview from './svgIcons/BookPodcastsInterview';
import GetPressMentions from './svgIcons/GetPressMentions';
import RecruitAffiliates from './svgIcons/RecruitAffiliates';
import KeyboardIcon from './svgIcons/KeyboardIcon';
import Gemini from './socialSvg/Gemini';
import UserVerifyIcon from './svgIcons/userVerifyIcon';
import AwardIcon from './svgIcons/AwardIcon';
import PowerIcon from './svgIcons/PowerIcon';
import ListIcon from '@uikit/old/Icon/svgIcons/ListIcon';
import ExpirationIcon from '@uikit/old/Icon/svgIcons/ExpirationIcon';
import GiftIcon from '@uikit/old/Icon/svgIcons/GiftIcon';
import LinkedinIcon2 from '@uikit/old/Icon/socialSvg/LinkedinIcon2';
import FacebookIcon2 from '@uikit/old/Icon/socialSvg/FacebookIcon2';
import InstagramIcon2 from '@uikit/old/Icon/socialSvg/InstagramIcon2';
import BlankIcon from '@uikit/old/Icon/svgIcons/BlankIcon';
import FriendsIcon from '@uikit/old/Icon/svgIcons/FriendsIcon';
import MoreIcon from '@uikit/old/Icon/svgIcons/MoreIcon';
import ClaudeIcon from '@uikit/old/Icon/svgIcons/ClaudeIcon';
import ChatGPTGreyicon from '@uikit/old/Icon/svgIcons/ChatGPTGreyicon';
import PlanetIcon from '@uikit/old/Icon/svgIcons/PlanetIcon';
import ReloadIcon from '@uikit/old/Icon/svgIcons/ReloadIcon';
import PictureIcon from '@uikit/old/Icon/svgIcons/PictureIcon';
import ApproveIcon from '@uikit/old/Icon/svgIcons/ApproveIcon';
import GuideListIcon from '@uikit/old/Icon/svgIcons/GuideListIcon';
import SendArrowIcon2 from '@uikit/old/Icon/svgIcons/sendArrowIcon2';
import PlayArrowInCircleNonBackground from '@uikit/old/Icon/svgIcons/PlayArrowInCircleNonBackground';
import BucketIcon from '@uikit/old/Icon/svgIcons/BucketIcon';
import LayerThreeIcon from '@uikit/old/Icon/svgIcons/LayerThreeIcon';
// Outline (stroke) icons that replaced the Lucide icon package (RES-7106)
import LineArrowUpIcon from './svgIcons/stroke/LineArrowUpIcon';
import LineArrowDownIcon from './svgIcons/stroke/LineArrowDownIcon';
import LineArrowUpDownIcon from './svgIcons/stroke/LineArrowUpDownIcon';
import ArrowUpRightIcon from './svgIcons/stroke/ArrowUpRightIcon';
import ArrowDownRightIcon from './svgIcons/stroke/ArrowDownRightIcon';
import ChevronUpIcon from './svgIcons/stroke/ChevronUpIcon';
import ChevronDownIcon from './svgIcons/stroke/ChevronDownIcon';
import ChevronRightIcon from './svgIcons/stroke/ChevronRightIcon';
import ExternalLinkOutlineIcon from './svgIcons/stroke/ExternalLinkOutlineIcon';
import LandmarkIcon from './svgIcons/stroke/LandmarkIcon';
import WalletOutlineIcon from './svgIcons/stroke/WalletOutlineIcon';
import ZapIcon from './svgIcons/stroke/ZapIcon';
import InfoOutlineIcon from './svgIcons/stroke/InfoOutlineIcon';
import TriangleAlertIcon from './svgIcons/stroke/TriangleAlertIcon';
import TrendingUpIcon from './svgIcons/stroke/TrendingUpIcon';
import TrendingDownIcon from './svgIcons/stroke/TrendingDownIcon';
import XMarkIcon from './svgIcons/stroke/XMarkIcon';
import MinusIcon from './svgIcons/stroke/MinusIcon';
import DownloadOutlineIcon from './svgIcons/stroke/DownloadOutlineIcon';
import AwardOutlineIcon from './svgIcons/stroke/AwardOutlineIcon';
import RefreshCwIcon from './svgIcons/stroke/RefreshCwIcon';

type IconPropsType = {
  icon: string;
  className?: string;
  id?: string;
  styles?: {
    [styleKey: string]: string;
  };
};

const iconMapper = {
  mail: mailIcon,
  person: personIcon,
  company: companyIcon,
  responaSmall,
  arrowLeftCircle,
  info,
  check,
  wallet,
  arrowDown,
  arrowUp,
  search,
  statusEdit,
  statusSwap,
  statusSuccess,
  statusPause,
  chevron,
};

const svgIconWrapper = {
  textLetter: TextLetterIcon,
  number: NumberIcon,
  ai: AiIcon,
  select: SelectIcon,
  teamMember: TeamMemberIcon,
  checkbox: CheckboxIcon,
  rating: RatingIcon,
  multiSelect: MultiSelectIcon,
  dateTime: DateTimeIcon,
  responaSmall: ResponaSmallIcon,
  upload: UploadIcon,
  visa: VisaIcon,
  minusCircle: MinusCircle,
  plusCircle: PlusCircle,
  plusIcon: PlusIcon,
  slidersSettings: SlidersSettings,
  copy: Copy,
  copyBold: CopyIcon2,
  copyRounded: CopyIcon3,
  arrowLeftCircle: ArrowLeftCircle,
  reload: ReloadIcon,
  arrowUpCircle: ArrowUpCircle,
  arrowLeft: ArrowLeft,
  arrowDown: ArrowDownIcon,
  arrowRightClassic: ArrowRightClassicIcon,
  info: Info,
  infinity: Infinity,
  trash: Trash,
  person: PersonIcon,
  personRounded: PersonRoundedIcon,
  personRoundedCrossed: PersonRoundedCrossedIcon,
  trashSimple: TrashSimpleIcon,
  messageIcon: MessageIcon,
  openMessageIcon: OpenMessageIcon,
  inboxUnreadMessage: InboxUnreadMessage,
  trashWhite: TrashWhiteIcon,
  boldText: BoldTextIcon,
  italicText: ItalicTextIcon,
  underlineText: UnderlineTextIcon,
  orderedList: OrderedListIcon,
  unorderedList: UnorderedListIcon,
  pen: Pen,
  inboxIcon: InboxIcon,
  penSquared: PenSquared,
  sidebarDashboardIcon: SidebarDashBoardIcon,
  search: SearchIcon,
  crossEdit: CrossEdit,
  crossInCircle: CrossInCircleIcon,
  calendar: CalendarIcon,
  prevPage: PrevPageIcon,
  notificationsIcon: NotificationsIcon,
  nextPage: NextPageIcon,
  user: UserIcon,
  duplicate: DuplicateIcon,
  cardio: CardioIcon,
  link: LinkIcon,
  linkIcon: LinkIcon,
  linkChain: LinkChainIcon,
  linkBroken: LinkBrokenIcon,
  externalLink: ExternalLinkIcon,
  location: LocationIcon,
  play: PlayIcon,
  playRounded: PlayRoundedIcon,
  pause: PauseIcon,
  profile: ProfileIcon,
  company: CompanyIcon,
  billing: BillingIcon,
  bill: BillIcon,
  workspace: WorkspacesIcon,
  removeRelationships: RemoveRelationshipsIcon,
  workspaceOut: WorkspaceOutIcon,
  member: MemberIcon,
  folder: FolderIcon,
  allMembers: AllMembersIcon,
  email: EmailIcon,
  emails: EmailsIcon,
  emailFind: EmailFind,
  emailVerify: EmailVerify,
  bookmark: BookmarkIcon,
  checklistItemSuccesIcon: ChecklistItemSuccesIcon,
  schedules: SchedulesIcon,
  crossDelete: CrossDeleteIcon,
  checkCircled: CheckCircledIcon,
  checkCircled2: CheckCircled2Icon,
  checkInCircle: CheckInCircleIcon,
  rocket: RocketIcon,
  crossBlack: CrossBlackIcon,
  warningTriangle: WarningTriangleIcon,
  warningTriangleCircle: WarningTriangleCircleIcon,
  launching: LaunchingIcon,
  successCircle: SuccessCircleIcon,
  successCircleFilled: SuccessCircleFilledIcon,
  actions: ActionsIcon,
  actionsTwoDots: TwoDotsActionsIcon,
  shareAction: ShareIcon,
  shareWithUsIcon: ShareWithUsIcon,
  editAction: EditActionIcon,
  renameAction: RenameActionIcon,
  envelope: EnvelopeIcon,
  check: CheckIcon,
  chevron: ChevronIcon,
  pencil: PencilIcon,
  pencilInCircle: PencilInCircle,
  lightBulb: LightBulbIcon,
  gear: GearIcon,
  close: CloseIcon,
  import: ImportIcon,
  allCampaignsSidebarIcon: AllCampaignsSidebarIcon,
  checkmark: GreyRoundCheckmarkIcon,
  checkmarkIcon: CheckMarkIcon,
  picture: PictureIcon,
  pauseBlue: PauseBlueIcon,
  playBlue: PlayBlueIcon,
  addUserWhite: AddUserWhiteIcon,
  arrowRightGrey: ArrowRightGreyIcon,
  windowSection: WindowSectionIcon,
  crown: CrownIcon,
  questionInCircle: QuestionInCircle,
  questionInCircleFilled: QuestionInCircleFilled,
  banWhite: BanWhiteIcon,
  tagWhite: TagWhiteIcon,
  inbox: InboxWhiteIcon,
  archived: ArchivedInboxIcon,
  textMessage: TextMessageIcon,
  folderWhite: FolderWhiteIcon,
  folderOpen: FolderOpenIcon,
  addCompany: AddCompanyIcon,
  insights: InsightsIcon,
  barChart: BarChartIcon,
  lineChart: LineChartIcon,
  layerThree: LayerThreeIcon,
  save: SaveIcon,
  video: VideoIcon,
  videoFile: ImageVideoFile,
  xIcon: XIcon,
  wallet: WalletIcon,
  wallet2: Wallet2Icon,
  list: List,
  crossList: CrossList,
  documentIcon: DocumentIcon,
  documentSignatureIcon: DocumentSignatureIcon,
  apple: AppleIcon,
  approve: ApproveIcon,
  guideList: GuideListIcon,
  rrs: RrsIcon,
  download: DownloadIcon,
  suitcase: SuitcaseIcon,
  building: BuildingIcon,
  comment: CommentIcon,
  profileCrossBig: ProfileCrossBigIcon,
  brackets: BracketsIcon,
  infoComment: InfoCommentIcon,
  filter: FilterIcon,
  doubleCheckmark: DoubleCheckmarkIcon,
  priceTag: PriceTagIcon,
  globe: GlobeIcon,
  downloadFile: DownloadFileIcon,
  star: StarIcon,
  starFilled: StarFilledIcon,
  flag: FlagIcon,
  flagStriped: FlagStripedIcon,
  curves: CurvesIcon,
  volume: VolumeIcon,
  volumeMute: VolumeMuteIcon,
  spinner: SpinnerIcon,
  spinnerDots: SpinnerDotsIcon,
  clockThree: ClockThreeIcon,
  refresh: RefreshIcon,
  editProfileImagePenIcon: EditProfileImagePenIcon,
  refreshOneArrowAround: RefreshIconOneArrowAround,
  creditCard: CreditCardIcon,
  logout: LogoutIcon,
  attachment: AttachmentIcon,
  image: ImageIcon,
  selectedOpportunities: SelectedOpportunitiesAbsoluteIcon,
  emptySelectedOpportunities: EmptySelectedOpportunitiesIcon,
  warningRoundedSignIcon: WarningRoundedSignIcon,
  errorInputFieldSignIcon: ErrorInputFieldSignIcon,
  plane: PlaneIcon,
  heart: HeartIcon,
  heartCross: HeartCrossIcon,
  basketball: BasketballIcon,
  userMinus: UserMinusIcon,
  userPlus: UserPlusIcon,
  expandSidebar: ExpandSidebarIcon,
  comments: CommentsIcon,
  trophy: TrophyIcon,
  trophyCross: TrophyCrossIcon,
  verifyiedOpportunityIcon: VerifyiedOpportunityIcon,
  sent: SentIcon,
  outbox: OutboxIcon,
  needAttention: NeedAttentionIcon,
  personWithMinus: PersonWithMinus,
  sequence: SequenceIcon,
  opportunities: OpportunitiesIcon,
  shield: ShieldIcon,
  bell: BellIcon,
  actionHorizontal: ActionHorizontal,
  fileBlank: FileBlankIcon,
  cornerUpLeftIcon: CornerUpLeftIcon,
  doubleCornerUpLeftIcon: DoubleCornerUpLeftIcon,
  chatUnfilled: ChatUnfilledIcon,
  spam: SpamIcon,
  archive: ArchiveIcon,
  snooze: SnoozeIcon,
  textAlignment: TextAlignmentIcon,
  textAlignmentLeft: TextAlignmentLeftIcon,
  textAlignmentRight: TextAlignmentRightIcon,
  textAlignmentCenter: TextAlignmentCenterIcon,
  connection: ConnectionIcon,
  angellist: AngelListIcon,
  appstore: AppStoreIcon,
  crunchbase: CrunchBaseIcon,
  facebook: FacebookIcon,
  github: GithubIcon,
  googleplay: GooglePlayIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
  linkedin2: LinkedinIcon2,
  facebook2: FacebookIcon2,
  instagram2: InstagramIcon2,
  medium: MediumIcon,
  penterest: PenterestIcon,
  quora: QuoraIcon,
  verifyPlayIcon: VerifyPlayIcon,
  checkmarkInCircleIcon: CheckmarkInCircleIcon,
  exclamationMarkInCircleIcon: ExclamationMarkInCircleIcon,
  pauseIcon: PauseIcon,
  pauseTall: PauseTallIcon,
  reddit: RedditIcon,
  snapchat: SnapchatIcon,
  spotify: SpotifyIcon,
  tiktok: TikTokIcon,
  twitter: TwitterIcon,
  youtube: YoutubeIcon,
  inquiries: InquiriesIcon,
  office: OfficeIcon,

  socketPlug: SocketPlugIcon,
  key: KeyIcon,
  lineChartMinimal: LineChartMinimalIcon,
  stopMessaging: StopMessagingIcon,
  notInterestedIcon: RepliedNotInterestedIcon,
  interestedIcon: RepliedInterestedIcon,
  wonIcon: RepliedWonIcon,
  lostIcon: RepliedLostIcon,
  cubesIcon,
  speechBoxIcon: SpeechBoxIcon,
  reportBox: ReportBox,
  scaleIcon: ScaleIcon,
  emailHealth: EmailHealthIcon,
  layoutIcon: LayoutIcon,
  rateGraphic: RateGraphic,
  curveGraph: CurveGraphIcon,
  downloadDocument: DownloadDocumentIcon,
  sortUpArrow: SortUpArrow,
  sortDownErrow: SortDownArrow,
  crosedIcon: CrosedIcon,
  arrowRefreshCircle: ArrowRefreshCircle,
  googleIcon: GoogleIcon,
  episodesIcon: EpisodesSVG,
  bingNewsIcon: BingNewsShortSVG,
  relationshipsIcon: RelationshipsSVG,
  podcastIcon: PodcastSVG,
  keywordSearchIcon: KeywordsSearcgSVG,
  csvImportSVG: CSVImportSVG,
  uploadFileIcon: UploadShortSVG,
  semrushIcon: SemrushSearchSvg,
  mozIcon: MozSVG,
  bingIcon: BingShortSVG,
  emailPersonalized: EmailPersonalized,
  userSearch: UserSearch,
  metricIcon: MetricIcon,
  crossInGreyCircle: CrossInGreyCircle,
  crossInRedCircle: CrossInRedCircle,
  playBig: PlayBigIcon,
  questionMark: QuestionMark,
  blueMark: BlueMark,
  folders: FoldersIcon,
  time: TimeIcon,
  cancelIcon: CancelIcon,
  cancelCircle: CancelCircle,
  lock: LockIcon,
  bookPodcastsInterview: BookPodcastsInterview,
  buildBacklinks: BuildBacklinks,
  getPressMentions: GetPressMentions,
  recruitAffiliates: RecruitAffiliates,
  keyboard: KeyboardIcon,
  threeDots: ThreeDots,
  house: House,
  lockGrey: LockGrey,
  pin: Pin,
  lightningArrow: LightningArrowIcon,
  lightningArrowInCircle: LightningArrowInCircle,
  playArrow: PlayArrowIcon,
  pieChart: PieChartIcon,
  refreshCircle: RefreshCircleIcon,
  flagMark: FlagMarkIcon,
  chatGPT: ChatGPTicon,
  chatGPTGrey: ChatGPTGreyicon,
  checkList: CheckListIcon,
  reduce: ReduceIcon,
  translate: TranslateIcon,
  relaxed: RelaxedSmile,
  briefCase: BriefCaseIcon,
  shySmile: ShySmileIcon,
  tearsSmile: TearsSmileIcon,
  label: LabelIcon,
  crossedOut: CrossedOutCircle,
  draft: draftIcon,
  assigned: AssignedPersonIcon,
  persons: PersonsIcon,
  statusBox: StatusBox,
  fullStar: FullStarIcon,
  avatarIcon: AvatarIcon,
  bounced: Bounced,
  dragAndDrop: DragAndDropIcon,
  recurringIcon: RecurringIcon,
  createdOpportunitiesIcon: CreatedOpportunitiesIcon,
  creditsIcon: CreditsIcon,
  flaggedIcon: FlaggedIcon,
  reportIcon: ReportIcon,
  coins: CoinsIcon,
  aiStar: aiStarIcon,
  sendArrow: SendArrowIcon,
  sendArrow2: SendArrowIcon2,
  duplicatePlus: Duplicate,
  aiIcon: AiAvatarIcon,
  viewIcon: ViewIcon,
  aiChat: AiChatIcon,
  configuration: ConfigurationIcon,
  bucketLink: BucketLinkIcon,
  squareLink: SquareLinkIcon,
  timer: TimerIcon,
  lightning: LightningIcon,
  toggle: ToggleIcon,
  question: QuestionIcon,
  planetWithCheckMark: PlanetWithCheckmark,
  taskCompleted: TaskCompleted,
  flashIcon: FlashIcon,
  linkSingleChain: LinkSingleChain,
  bucketWithArrow: BucketWithArrow,
  bucketInCircle: BucketInCircleIcon,
  bucketIcon: BucketIcon,
  widget: WidgetIcon,
  easel: EaselIcon,
  playArrowInCircle: PlayArrowInCircle,
  playArrowInCircleNonBG: PlayArrowInCircleNonBackground,
  threeDotsInCircle: ThreeDotsInCircle,
  eyeInCircle: EyeInCircle,
  invoice: InvoiceIcon,
  downloadInCircle: DownloadInCircle,
  purpleStar: PurpleStarIcon,
  penInCircle: PenInCircle,
  creditCardWithPlus: CreditCardWithPlus,
  twoStar: TwoStarIcon,
  twoAiStars: TwoAiStartsIcon,
  model: ModelIcon,
  manual: ManualIcon,
  sparkles: SparklesIcon,
  userVerify: UserVerifyIcon,
  award: AwardIcon,
  power: PowerIcon,
  listAndStar: ListIcon,
  expiration: ExpirationIcon,
  gift: GiftIcon,
  blank: BlankIcon,
  friends: FriendsIcon,
  more: MoreIcon,
  claude: ClaudeIcon,
  planet: PlanetIcon,
  ChatGPT,
  Claude,
  GoogleAi,
  Perplexity,
  AIOverviews,
  Gemini,
  // Outline (stroke) icons, 24x24 / currentColor, ex Lucide package (RES-7106)
  lineArrowUp: LineArrowUpIcon,
  lineArrowDown: LineArrowDownIcon,
  lineArrowUpDown: LineArrowUpDownIcon,
  arrowUpRight: ArrowUpRightIcon,
  arrowDownRight: ArrowDownRightIcon,
  chevronUp: ChevronUpIcon,
  chevronDown: ChevronDownIcon,
  chevronRight: ChevronRightIcon,
  externalLinkOutline: ExternalLinkOutlineIcon,
  landmark: LandmarkIcon,
  walletOutline: WalletOutlineIcon,
  zap: ZapIcon,
  infoOutline: InfoOutlineIcon,
  triangleAlert: TriangleAlertIcon,
  trendingUp: TrendingUpIcon,
  trendingDown: TrendingDownIcon,
  xMark: XMarkIcon,
  minus: MinusIcon,
  downloadOutline: DownloadOutlineIcon,
  awardOutline: AwardOutlineIcon,
  refreshCw: RefreshCwIcon,
};

export type SvgIconType = keyof typeof svgIconWrapper;

export default function ({ icon, className, styles, ...rest }: IconPropsType): JSX.Element {
  return <img style={styles} src={iconMapper[icon]} className={className} {...rest} alt="" />;
}

export function SVGIcon({
  icon,
  className,
  ...rest
}: {
  icon: SvgIconType;
  className?: string;
  color?: string;
  size?: number;
  backgroundIcon?: string;
  [key: string]: any;
}): JSX.Element {
  const Component = svgIconWrapper[icon];

  if (!Component) {
    return null;
  }

  // @ts-ignore
  return <Component {...rest} className={className} />;
}
